import React from 'react'
import { Button, type ButtonProps } from '@mantine/core'

export type AppButtonProps = ButtonProps;

export default function AppButton (props: AppButtonProps) {
  return <Button color="ember" radius="sm" {...props} />
}
